import React from "react"
import styled from "styled-components";
import Media from "../types/Media"

const ArtworkImg = styled.img`
  width: 100%;
  aspect-ratio: 1;
  display: block;
  object-fit: cover;
  background: #222;
`;

interface IMediaArtProps {
    media: Media
    size: string
  }


export function MediaArt(prop: IMediaArtProps): JSX.Element {

      let mod = prop.media.artwork_url.replace("{w}x{h}", prop.size);
      return <ArtworkImg src={mod} />;
  }
